import { colors } from './settings';

const colorThemes = {
  default: {
    primary: colors.white,
    secondary: colors.darkGray,
    tertiary: colors.lightGray,
    borderColor: colors.black,
    focusColor: colors.pink,
    loading: colors.black,
    contrastCta: colors.black
  },
  berry: {
    primary: '#ff4ced',
    secondary: '#c4295d',
    tertiary: '#f03874',
    borderColor: '#ff4ced',
    focusColor: '#ff4ced',
    loading: '#f03874',
    contrastCta: '#C4295D'
  },
  caribbean: {
    primary: '#60edb2',
    secondary: '#c6d6d5',
    tertiary: '#6fb497',
    borderColor: '#60edb2',
    focusColor: '#60edb2',
    loading: '#6fb497',
    contrastCta: '#007142'
  },
  green: {
    primary: '#59b592',
    secondary: '#cad5d5',
    tertiary: '#e3fc5e',
    borderColor: '#59b592',
    focusColor: '#59b592',
    loading: '#e3fc5e',
    contrastCta: '#287759'
  },
  pop: {
    primary: '#f2a4a2',
    secondary: '#14b9b2',
    tertiary: '#7284b6',
    borderColor: '#f2a4a2',
    focusColor: '#f2a4a2',
    loading: '#7284b6',
    contrastCta: '#AC3A37'
  },
  sun: {
    primary: '#fdb843',
    secondary: '#e7f669',
    tertiary: '#e7772f',
    borderColor: '#fdb843',
    focusColor: '#fdb843',
    loading: '#e7772f',
    contrastCta: '#965E00'
  },
  blue: {
    primary: '#6fc3f6',
    secondary: '#606dee',
    tertiary: '#578df0',
    borderColor: '#6fc3f6',
    focusColor: '#6fc3f6',
    loading: '#578df0',
    contrastCta: '#1770A6'
  },
  turquoise: {
    primary: '#71f2ed',
    secondary: '#14b9b2',
    tertiary: '#22eee5',
    borderColor: '#71f2ed',
    focusColor: '#71f2ed',
    loading: '#22eee5',
    contrastCta: '#03706C'
  },
  lab1: {
    primary: colors.greenOne,
    secondary: colors.greenTwo,
    tertiary: colors.greenThree,
    borderColor: colors.greenOne,
    focusColor: colors.greenOne,
    loading: colors.greenThree,
    contrastCta: '#317559'
  },
  lab2: {
    primary: colors.greenThree,
    secondary: colors.greenFour,
    tertiary: colors.greenFive,
    borderColor: colors.greenThree,
    focusColor: colors.greenThree,
    loading: colors.greenFive,
    contrastCta: '#4A7552'
  }
};

// Returns object of global and page themes for styled components
const getThemes = (baseFontSize = 100, globalTheme = 'default', siteTheme = 'default') => {
  return siteTheme && globalTheme && colorThemes[siteTheme] && colorThemes[globalTheme]
    ? {
        siteTheme: colorThemes[siteTheme],
        globalTheme: colorThemes[globalTheme],
        baseFontSize
      }
    : {
        siteTheme: colorThemes.default,
        globalTheme: colorThemes.default,
        baseFontSize
      };
};

export { colorThemes, getThemes };
